import { FC } from 'react';
import { WbTruncatedTypographyWrapper } from '@agilelab/plugin-wb-platform';
import { Box, Typography, makeStyles } from '@material-ui/core';

type IssuesProps = {
  issues: string[] | undefined;
};

const useStyles = makeStyles(
  theme => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
    },
    issueContainer: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: theme.spacing(1),
    },
  }),
  { name: 'Issues' },
);

export const Issues: FC<IssuesProps> = ({ issues }) => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      {issues
        ?.map(i => `${i}`)
        .map(i => (
          <Box className={classes.issueContainer}>
            <Typography variant="body2">•</Typography>
            <WbTruncatedTypographyWrapper value={i} variant="body2" />
          </Box>
        ))}
    </Box>
  );
};
